import { render, staticRenderFns } from "./RedirectIOS.vue?vue&type=template&id=4109052c&scoped=true&"
var script = {}
import style0 from "./RedirectIOS.vue?vue&type=style&index=0&id=4109052c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109052c",
  null
  
)

export default component.exports